// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"d79ec967","693":"2f815585","845":"85b293e8","983":"9e1e8043"}[chunkId] + ".chunk.js";
};